<template>
  <div class="my_collapse">
    <slot></slot>
  </div>
</template>

<script>
import i18n from '../../language/index'

  export default {
    name: 'my_collapse',
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },
    watch: {
      value (value) {
        this.activeNames = value
      }
    },
    provide() {
      return {
        collapse: this
      }
    },
    data () {
      return {
        activeNames: this.value
      }
    },
    created() {
      this.$on('item-click', this.handleItemClick);
    },
    methods: {
      handleItemClick (item) {
        let activeNames = this.activeNames.slice(0)
        let index = activeNames.indexOf(item.name)
        let status = false
        if (index > -1) {
          activeNames.splice(index, 1)
          status = false
        } else {
          activeNames.push(item.name)
          status = true
        }
        this.setActiveNames(activeNames, item.name, status)
      },
      setActiveNames (activeNames, name, status) {
        this.activeNames = activeNames;
        this.$emit('input', activeNames);
        this.$emit('change', activeNames);
        this.$emit('change-item', { name: name, status: status })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/my_collapse/my_collapse.vue